"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    text: function (_a) {
        var theme = _a.theme, color = _a.color, variant = _a.variant, size = _a.size;
        return (__assign(__assign(__assign({}, theme_1.getFontStyles(theme)), theme_1.getFocusStyles(theme)), { color: color in theme.colors
                ? theme.colors[color][theme.colorScheme === 'dark' ? 4 : 6]
                : variant === 'link'
                    ? theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]
                    : theme.colorScheme === 'dark'
                        ? theme.colors.dark[0]
                        : theme.black, fontSize: theme.fontSizes[size], lineHeight: theme.lineHeight, textDecoration: 'none', WebkitTapHighlightColor: 'transparent', '&:hover': {
                textDecoration: variant === 'link' ? 'underline' : 'none',
            } }));
    },
}, { link: true });
